// Articles shown under /inspiration -> read on /artikler/:slug
export const ARTICLES = [
  {
    slug: "haardt-sagt-men-rigtigt",
    eyebrow: "Brand & strategi",
    title: "Hårdt sagt. Men rigtigt.",
    excerpt:
      "Alt for mange virksomheder betaler dyre strategikonsulenter for personlige smagsdomme. Her er den ubehagelige - men veldokumenterede - sandhed om, hvad der faktisk virker.",
    readTime: "2 min.",
    blocks: [
      { type: "p", text: "Alt for mange virksomheder betaler strategikonsulenter i dyre domme for at trække personlige smagsdomme ned over deres brand." },
      { type: "p", text: "Den ene siger, du skal lave en podcast. Den næste siger, det skal være mere personligt. En tredje siger \u201Cmere corporate\u201D." },
      { type: "p", text: "De taler, som om dit brand er noget, folk går og tænker på hele tiden. Men sandheden? For din målgruppe fylder dit brand\u2026 ingenting." },
      { type: "p", text: "De ser dig i et splitsekund - hvis du er heldig - og så scroller de videre. Problemet opstår, når man ikke accepterer den præmis. Så risikerer man at jagte det næste gode råd, den næste nuance, den næste smarte idé." },
      { type: "p", text: "Jo mere I zigzagger, desto mindre forstår folk, hvem I er. Imens ryger budgettet til strategi, slides og konsulenter med overbevisende smil." },
      { type: "h", text: "Det, I burde gøre, er enkelt" },
      { type: "p", text: "Vær synlig. Vær genkendelig. Sig noget enkelt - og gentag det." },
      { type: "p", text: "Effekten i B2B kommer ikke fra kompleksitet, men fra klarhed og evnen til at være til stede nok gange til, at folk husker jer, når de endelig er klar til at købe." },
      { type: "p", text: "Spørgsmålet er: Bygger jeres nuværende setup systematisk kendskab - eller skyder I bare med spredehagl for at \u201Cvære i gang\u201D?" },
    ],
  },
  {
    slug: "synlighed-trumfer-pistolsalg",
    eyebrow: "Vækst",
    title: "Derfor trumfer synlighed pistolsalg",
    excerpt:
      "Vi køber ikke nødvendigvis det bedste produkt - vi køber det, vi kan huske. Derfor slår vedholdende synlighed hårdt sælgeri hver gang.",
    readTime: "2 min.",
    blocks: [
      { type: "p", text: "Du står i butikken eller scroller online, og der er 20 forskellige mærker. Hvilket vælger du?" },
      { type: "p", text: "Sandsynligvis et, du har hørt om før. Måske et, du har set en reklame for. Eller et, din kollega nævnte i frokostpausen." },
      { type: "p", text: "Pointen? Vi køber ikke nødvendigvis det bedste produkt - vi køber det, vi kan huske." },
      { type: "h", text: "Fra push til pull" },
      { type: "p", text: "I stedet for at mase kunderne til et køb (pistolsalg) handler det om at være top of mind, når de selv er klar." },
      { type: "p", text: "Det er her, Aicom kommer ind i billedet. Vores AI-værktøjer sikrer, at dit brand bliver set igen og igen - uden at du skal jagte hvert eneste salg manuelt." },
      { type: "p", text: "Så spørgsmålet er ikke: Hvordan får jeg folk til at købe lige nu? Spørgsmålet er: Er du synlig nok, når de skal tage en beslutning?" },
    ],
  },
  {
    slug: "ai-er-ikke-magi",
    eyebrow: "AI i praksis",
    title: "AI er ikke magi",
    excerpt:
      "AI er blevet talt op som noget futuristisk og halvmagisk. Sandheden er langt enklere - og langt mere brugbar.",
    readTime: "2 min.",
    blocks: [
      { type: "p", text: "Når vi siger, vi arbejder med AI-drevet markedsføring, får vi tit et blik, der siger: \u201CDet lyder spændende - men også lidt\u2026 avanceret.\u201D" },
      { type: "p", text: "Fair nok. For AI er blevet talt op som noget futuristisk og halvmagisk. Men sandheden er enklere:" },
      { type: "p", text: "AI handler ikke om robotter, der overtager verden. Det handler om at bruge data til at træffe smartere, gentagelige beslutninger." },
      { type: "h", text: "Sådan bruger vi AI" },
      { type: "list", items: [
        "Skrive udkast til annoncer og nyhedsbreve.",
        "Generere grafik og kampagnemateriale.",
        "Teste, måle og optimere hurtigere, end mennesker kan alene.",
      ] },
      { type: "p", text: "Og vigtigst af alt: Vi bruger det der, hvor det giver mening - og ikke der, hvor det skaber rod." },
      { type: "p", text: "AI giver dig ikke bare mere indhold. Det giver dig mere klarhed - og mere tid. Fordi vi slipper for at starte fra nul hver gang og kan bruge energien på det, der faktisk rykker." },
      { type: "p", text: "Så nej, du behøver ikke være teknisk anlagt. Du skal bare være nysgerrig - og klar til at tænke lidt mere effektivt." },
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
